import { Base } from "@/components/Product/ECommerce/components/delivery/components/amount/amount.base";

export const Amount = Object.assign(Base, {});
